import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { LastDraft } from '../../types/analytics';
import { PlusIcon } from '@heroicons/react/24/outline';
import RecentBannerIcon from '@/components/icons/RecentBannerIcon';
import { EASE_OUT } from '@/lib/motion';

interface LastDraftCardProps {
  draft: LastDraft | null;
}

function RecentTab() {
  return (
    <div className="absolute left-[24px] top-[19px] bottom-0 w-[49px] z-10">
      <RecentBannerIcon></RecentBannerIcon>
    </div>
  );
}

const LastDraftCard: React.FC<LastDraftCardProps> = ({ draft }) => {
  const linkTo = draft ? `/courses/${draft.id}/edit` : '/courses/create';

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: EASE_OUT }}
      data-testid="last-draft-card"
    >
      <Link
        to={linkTo}
        className="relative block rounded-2xl bg-neutral-100 dark:bg-grey-900 min-h-[192px] hover:ring-2 hover:ring-primary-400/40 transition-shadow"
      >
        <RecentTab />

        {/* Content — offset to clear the pill tab */}
        <div className="flex flex-col justify-center gap-2 pl-[100px] pr-10 py-10 h-full min-h-[192px]">
          {draft ? (
            <>
              <h3 className="text-primary-400 text-[32px] leading-[32px] font-semibold line-clamp-2">
                {draft.title}
              </h3>
              <p className="text-text-secondary dark:text-white/60 text-sm">
                Pick it where you left it
              </p>
            </>
          ) : (
            <>
              <div className="w-10 h-10 rounded-full bg-primary-500/10 flex items-center justify-center mb-1">
                <PlusIcon className="w-5 h-5 text-primary-400" />
              </div>
              <h3 className="text-primary-400 text-[22px] leading-[30px] font-semibold">
                Create a new course
              </h3>
              <p className="text-text-secondary dark:text-white/60 text-sm">
                Start building your next learning experience
              </p>
            </>
          )}
        </div>
      </Link>
    </motion.div>
  );
};

export default LastDraftCard;
